import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './CaseSmall.module.scss';

export default class CaseSmallComponent extends Component {
  static defaultProps = {
    className: ''
  };
  static propTypes = {
    caseStudy: PropTypes.object.isRequired
  };

  render() {
    const { className, caseStudy } = this.props;
    const {
      title,
      publicationDate,
      link,
      company: { logo }
    } = caseStudy;

    return (
      <div className={`${styles.CaseSmall} ${className}`}>
        <h4 className={styles.Title}>
          {link.isValid() ? (
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {title}
            </a>
          ) : (
            title
          )}
        </h4>
        <p className={styles.Date}>
          {moment(publicationDate).format('DD.MM.YYYY')}
        </p>
        {link.isValid() && <p className={styles.URL}>{link.origin}</p>}
        <div className={styles.IMGWrapper}>
          <img src={OptimizeImagesService.adjustImageSize(logo)} alt="logo" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/SimpleCaseStudy/components/CaseSmall/CaseSmall.js